/**
 * wechat_query接口相关
 */

import Api from '@/api/index'

/**
 * 通过模型获取推荐数据
 */
export default async function recommend({ model }: { model: string }): Promise<RecommendResult | null> {
  const apiParams = {
    cmd: 26,
    model
  }

  if (!Api || !Api.cgiObj.request) {
    return null
  }

  return Api.request('wechatQuery', apiParams)
}
